.outerWrapper {
  background-color: #022e4a;
  background-image:
    linear-gradient(
      to bottom,
      rgba(2, 46, 74, 0.8) 0%,
      rgba(2, 46, 74, 0) 25%,
      rgba(2, 46, 74, 0) 55%,
      rgba(2, 46, 74, 1) 85%
    ),
    var(--bg-image, none);
  background-size:
    100% 100%,
    100% auto;
  background-position:
    top center,
    top center;
  background-repeat: no-repeat, no-repeat;
  display: flex;
  flex-direction: column;
  min-height: 100vh;
}

.innerContainer {
  width: 100%;
  max-width: 1440px;
  margin: 0 auto;
  flex: 1;
  display: flex;
  flex-direction: column;
}

.top {
  min-height: 76px;
}

.centerGrid {
  display: grid;
  flex: 1;
  grid-template-columns: 1fr;
  grid-template-rows: auto auto;
  grid-template-areas:
    'right'
    'left';
}

@media (min-width: 1024px) {
  .centerGrid {
    grid-template-columns: 1fr 1fr;
    grid-template-rows: 1fr;
    grid-template-areas: 'left right';
  }
}

.centerLeft {
  grid-area: left;
  min-height: 150px;
}

.centerRight {
  grid-area: right;
  min-height: 150px;
  padding: 32px 16px;
  display: flex;
  justify-content: center;
  align-items: flex-start;
}

@media (min-width: 1024px) {
  .centerRight {
    justify-content: flex-end;
  }
}

.centerBottom {
  min-height: 150px;
}

.bottom {
  min-height: 100px;
}
